export default {
  computed: {
    items () {
      return this.$store.state.works
    },

    slug () {
      return this.$route.params.slug || null
    },

    item () {
      const data = this.items.filter(i => i.slug === this.slug)[0]
      if (!this.slug || !data) {
        return {
          title: 'Oferta de trabajo no encontrada',
          isError: true,
        }
      }
      // data.image = require(`@/assets/${data.image}`)
      return data
    },

    imagenPrincipal () {
      return !this.item.isError ? this.item.galeria[0] : null
    },
  },

  methods: {
    checkWorks () {
      if (this.items.length) {
        return
      }
      this.$store.dispatch('getWorks')
    },
  },

  mounted () {
    this.checkWorks()
  },
}
